// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CS3S7 {\n  visibility: visible;\n  width: auto;\n  height: auto;\n  position: relative;\n}\n\n.VamjT {\n  visibility: hidden;\n  width: 0;\n  height: 0;\n  position: fixed;\n}\n\n.jDkEj {\n  margin: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shown": "CS3S7",
	"hidden": "VamjT",
	"mobile": "jDkEj"
};
export default ___CSS_LOADER_EXPORT___;
